<template>
  <div>
    <div class="header pb-8 pt-lg-8 d-flex align-items-center profile-header">
      <b-container fluid>
        <span class="mask bg-gradient-success opacity-8"></span>

        <b-container fluid class="d-flex align-items-center">
          <b-row>
            <b-col lg="7" md="10"> </b-col>
          </b-row>
        </b-container>
      </b-container>
    </div>

    <b-container fluid class="mt--7">
      <b-row>
        <b-col>
          <card>
            <b-row align-v="center" slot="header">
              <b-col cols="8">
                <base-button
                  @click="tipoFormulario = 1"
                  size="lg"
                  :type="tipoFormulario == 1 ? 'primary' : 'secondary'"
                  >Editor de Cursos</base-button
                >

                <base-button
                  v-if="$store.getters.getTipoPrivilegiosUsuario == 'SU'"
                  @click="tipoFormulario = 2"
                  size="lg"
                  :type="tipoFormulario == 2 ? 'primary' : 'secondary'"
                  >Editor Catequistas</base-button
                >
              </b-col>
            </b-row>
            <editor-cursos v-if="tipoFormulario == 1" />
            <editor-catequistas v-if="tipoFormulario == 2" />
          </card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import EditorCursos from "./GestionCursosCatequesis.vue";
import EditorCatequistas from "./GestionCatequistas.vue";
import UserCard from "../Pages/UserProfile/UserCard.vue";

export default {
  name: "gestionGrupos",
  components: {
    UserCard,
    EditorCursos,
    EditorCatequistas,
  },
  data() {
    return {
      tipoFormulario: 1,
    };
  },
  methods: {
    editarCatecumeno() {},
  },
};
</script>
<style></style>
